import React, { useEffect } from "react"
import {
  BlogGridWrapper,
  BlogGrid2xWrapper,
  BlogGridSlide,
  BlogGalleryControls,
  BlogGridGallery,
  BlogGridGallery2,
  BlogGridPost,
  BlogGrid2xPost,
  BlogGridPostLeft,
  BlogPostTitle,
  BlogPostContent,
  BlogPostLink,
  BlogPostDate,
  BlogGridPostRight,
} from "./blog-grid-styles"
import PortableText from "@sanity/block-content-to-react"
import Img from "gatsby-image"
import anime from "animejs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons"

const BlogGrid = data => {
  const array = data.posts
  const array2 = data.rest
  const gallery1 = data.treeshoot
  const gallery2 = data.beachshoot

  useEffect(() => {
    const slides = document.querySelectorAll(".slide:not(.current)")

    slides.forEach(slide => {
      anime({
        targets: slide,
        translateX: "100%",
        duration: 1,
      })
    })
  })

  function next_slide(e) {
    const parent = e.currentTarget.parentElement.parentElement
    const current = parent.querySelector(".current")
    let next = null
    if (current.nextElementSibling) {
      next = current.nextElementSibling
    } else {
      next = current.parentElement.childNodes[1]
    }

    change_slide(current, next, "-100%", "100%")
  }

  function prev_slide(e) {
    const parent = e.currentTarget.parentElement.parentElement
    const current = parent.querySelector(".current")
    let prev = null
    if (current.previousElementSibling) {
      prev = current.previousElementSibling
      if (prev.classList.contains("controls")) {
        prev = parent.childNodes[parent.childNodes.length - 1]
      }
    } else {
      prev = parent.childNodes[parent.childNodes.length - 1]
    }

    change_slide(current, prev, "100%", "-100%")
  }

  function change_slide(current, next, currentDir, nextDir) {
    anime({
      targets: current,
      translateX: currentDir,
      duration: 400,
      easing: "easeInOutCubic",
      complete: () => {
        current.classList.remove("current")
        next.classList.add("current")

        anime({
          targets: current,
          translateX: nextDir,
          duration: 1,
        })
      },
    })

    anime({
      targets: next,
      translateX: "0",
      duration: 400,
      easing: "easeInOutCubic",
    })
  }

  return (
    <>
      <BlogGridWrapper>
        <BlogGridGallery className="anim-in-up">
          <BlogGalleryControls className="controls">
            <FontAwesomeIcon
              icon={faChevronLeft}
              size="3x"
              onClick={e => prev_slide(e)}
            />
            <p>Scroll through these shots from our awesome photo shoot!</p>
            <FontAwesomeIcon
              icon={faChevronRight}
              size="3x"
              onClick={e => next_slide(e)}
            />
          </BlogGalleryControls>
          {Array.from(gallery1).map((pic, index) => {
            let cls = ""
            if (index === 0) {
              cls = "current slide"
            } else {
              cls = "slide"
            }
            return (
              <BlogGridSlide
                key={index}
                className={cls}
                fluid={pic.image.asset.fluid}
                alt={pic.alt}
                data-slide-index={index}
              />
            )
          })}
        </BlogGridGallery>
        {Array.from(array).map((single, index) => (
          <BlogGridPost className="anim-in-up" key={index}>
            <BlogGridPostLeft>
              <BlogPostTitle>{single.node.title}</BlogPostTitle>
              <BlogPostContent>
                <PortableText
                  blocks={single.node._rawContent}
                  serializers={{
                    types: {
                      ptImage: ({ node }) => <></>,
                    },
                  }}
                />
              </BlogPostContent>
              <BlogPostLink to={"/blog/" + single.node.slug.current + "/"}>
                Read More
              </BlogPostLink>
              <BlogPostDate>
                {new Date(single.node.publishedAt)
                  .toDateString()
                  .split(" ")
                  .slice(1)
                  .join(" ")}
              </BlogPostDate>
            </BlogGridPostLeft>
            <BlogGridPostRight>
              <Img fluid={single.node.featuredImage.image.asset.fluid} />
            </BlogGridPostRight>
          </BlogGridPost>
        ))}
        <BlogGridGallery2 className="anim-in-down">
          <BlogGalleryControls className="controls">
            <FontAwesomeIcon
              icon={faChevronLeft}
              size="3x"
              onClick={e => prev_slide(e)}
            />
            <p>Scroll through these shots from our awesome photo shoot!</p>
            <FontAwesomeIcon
              icon={faChevronRight}
              size="3x"
              onClick={e => next_slide(e)}
            />
          </BlogGalleryControls>
          {Array.from(gallery2).map((pic, index) => {
            let cls = ""
            if (index === 0) {
              cls = "current slide"
            } else {
              cls = "slide"
            }
            return (
              <BlogGridSlide
                key={index}
                className={cls}
                fluid={pic.image.asset.fluid}
                alt={pic.alt}
                data-slide-index={index}
              />
            )
          })}
        </BlogGridGallery2>
      </BlogGridWrapper>
      <BlogGrid2xWrapper>
        {Array.from(array2).map((single, index) => (
          <BlogGrid2xPost className="anim-in-up" key={index}>
            <BlogGridPostLeft>
              <BlogPostTitle>{single.node.title}</BlogPostTitle>
              <BlogPostContent>
                <PortableText
                  blocks={single.node._rawContent}
                  serializers={{
                    types: {
                      ptImage: ({ node }) => <></>,
                    },
                  }}
                />
              </BlogPostContent>
              <BlogPostLink to={"/blog/" + single.node.slug.current + "/"}>
                Read More
              </BlogPostLink>
              <BlogPostDate>
                {new Date(single.node.publishedAt)
                  .toDateString()
                  .split(" ")
                  .slice(1)
                  .join(" ")}
              </BlogPostDate>
            </BlogGridPostLeft>
            <BlogGridPostRight>
              <Img fluid={single.node.featuredImage.image.asset.fluid} />
            </BlogGridPostRight>
          </BlogGrid2xPost>
        ))}
      </BlogGrid2xWrapper>
    </>
  )
}

export default BlogGrid
